import { useCallback } from 'preact/hooks';
import useAppSelector from '../../hooks/useAppSelector';
import './AssistantBackdrop.less';

export type AssistantBackdropProps = {
    onClick?: () => void;
};

const AssistantBackdrop = ({ onClick }: AssistantBackdropProps) => {
    const { mode } = useAppSelector(state => state.uiState);
    const onBackdropClick = useCallback(
        (event: MouseEvent) => {
            if (
                mode === 'full' &&
                (event.target as HTMLDivElement).classList.contains(
                    'bri-AssistantBackdrop'
                )
            ) {
                onClick && onClick();
            }
        },
        [mode]
    );
    return (
        <div
            className={`bri-AssistantBackdrop bri-AssistantBackdrop-mode-${mode}`}
            onClick={onBackdropClick}
        >
            &nbsp;
        </div>
    );
};

export default AssistantBackdrop;
